module.exports = __webpack_public_path__ + "img/list3.b7b163d5.png";